export const updateMetodosPago = async ({ commit, state }) => {
    await axios.get('/api/v1/facturacion/metodospago').then((response) => {
        const {data} = response.data
        commit('SET_METODOS_PAGO', data.metodospago)
        commit('SET_SERVICIOS_COMPRA_CO', data.servicioscompra)
        commit('SET_SERVICIOS_SENAVEX', data.serviciossenavex)

    })
}
